import { Link } from "react-router-dom";

const entries = [
  {
    title: "电影频道",
    subtitle: "MOTION PICTURES",
    desc: "从院线新片到经典佳作，按类型、年代与热度快速筛选你想看的电影。",
    to: "/category/movie",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20collage%20of%20movie%20theater%20elements%2C%20glowing%20projector%20beam%20through%20dark%20auditorium%2C%20seats%20and%20flickering%20screen%2C%20deep%20blue%20and%20amber%20tones%2C%20atmospheric%20film%20mood&width=800&height=520&seq=cat-entry-movie&orientation=landscape",
    count: "10 部精选作品",
  },
  {
    title: "电视剧频道",
    subtitle: "TV SERIES",
    desc: "都市、悬疑、古装、奇幻，追剧党的完整片单与剧情脉络一网打尽。",
    to: "/category/tv",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20and%20binge-watching%20atmosphere%2C%20warm%20lamplight%2C%20deep%20blue%20shadows%2C%20inviting%20mood&width=800&height=520&seq=cat-entry-tv&orientation=landscape",
    count: "10 部精选剧集",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-accent-600">EXPLORE</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            分类快捷入口
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          不知道看什么？先从大分类逛起，电影与电视剧的完整片单都在这里。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex h-64 flex-col justify-end overflow-hidden rounded-lg md:h-72"
          >
            <img
              src={entry.image}
              alt={`${entry.title} 入口图`}
              title={`${entry.title} 影视作品分类`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-primary-950/10" />
            <div className="relative z-10 p-6 md:p-7">
              <p className="text-[11px] font-semibold tracking-[0.22em] text-accent-400">
                {entry.subtitle}
              </p>
              <h3 className="mt-2 font-heading text-2xl font-bold text-background-50">
                {entry.title}
              </h3>
              <p className="mt-2 max-w-sm text-sm leading-relaxed text-background-200">
                {entry.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-background-50">
                {entry.count}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}